/*
 * action types
 */

export const REPLACE = "REPLACE_CASHREGISTERS";
export const CLEAR = "CLEAR_CASHREGISTERS";
export const SET_CASHREGISTERS_FILTERS = "SET_CASHREGISTERS_FILTERS";
export const SET_CASHREGISTERS_PAGESIZE = "SET_CASHREGISTERS_PAGESIZE";
export const SET_CASHREGISTERS_PAGENUMBER = "SET_CASHREGISTERS_PAGENUMBER";
export const DELETE_CASHREGISTER = "DELETE_CASHREGISTER";

/*
 * action creators
 */

export const Replace = (values, totalResults, totalPage) => ({ 
    type : REPLACE,
    cashRegisters: values,
    totalResults,
    totalPage,
});

export const Clear = () => ({
    type: CLEAR
})

export const SetPageSize = (pageSize) => ({
    type: SET_CASHREGISTERS_PAGESIZE,
    pageSize
})

export const SetPageNumber = (pageNumber) => ({
    type: SET_CASHREGISTERS_PAGENUMBER,
    pageNumber
})

export const SetFilters = (filters) => ({
    type: SET_CASHREGISTERS_FILTERS,
    filters
})